import React, { Component } from "react";

export default class Assignment extends Component {
  render() {
    return <div>Assignment will be placed here</div>;
  }
}
